"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReadyLiveStream = exports.isPendingLiveStream = exports.isStreamingLive = exports.isScheduledLive = void 0;
var item_type_1 = require("@wix/wix-vod-constants/dist/api-types/enums/item-type");
var live_statuses_1 = require("@wix/wix-vod-constants/dist/common/live-statuses");
var isScheduledLive = function (_a) {
    var itemType = _a.itemType;
    return itemType === item_type_1.ItemType.ItemScheduled;
};
exports.isScheduledLive = isScheduledLive;
var isStreamingLive = function (_a) {
    var itemType = _a.itemType;
    return itemType === item_type_1.ItemType.ItemLive;
};
exports.isStreamingLive = isStreamingLive;
var isPendingLiveStream = function (_a) {
    var liveVideoStatus = _a.liveVideoStatus;
    return liveVideoStatus === live_statuses_1.LIVE_VIDEO_STATUS.PENDING;
};
exports.isPendingLiveStream = isPendingLiveStream;
var isReadyLiveStream = function (_a) {
    var liveVideoStatus = _a.liveVideoStatus;
    return liveVideoStatus === live_statuses_1.LIVE_VIDEO_STATUS.IN_PROGRESS;
};
exports.isReadyLiveStream = isReadyLiveStream;
//# sourceMappingURL=live.js.map